<div class="about">
  <div class="about--container">
    <div class="about--content">
      <!-- Left Side: Text Content -->
      <div class="about--text-card">
        <h2 class="about--title">About MahaAgX</h2>

        <h3 class="about--subtitle">What is MahaAgX?</h3>
        <p class="about--description">
          MahaAgX is a state-led Digital Public Infrastructure that enables trusted sharing of agricultural data across departments, institutions, startups, and industry, while preserving data ownership, privacy, and governance.
        </p>

        <h3 class="about--subtitle">Why MahaAgX?</h3>
        <ul class="about--list">
          <li>Agricultural data exists but remains siloed &amp; fragmented.</li>
          <li>AI &amp; analytics need trusted, high-quality data.</li>
          <li>Farmers &amp; policymakers need faster, better decisions.</li>
        </ul>
        <p class="about--description">
          MahaAgX connects data providers and data users through a trusted, policy-driven exchange network for researchers, innovators, and policymakers.
        </p>

      </div>

      <!-- Right Side: Image -->
      <div class="about--image-card">
        <img
          src="/about-us/theCurrentProblem.png"
          alt="MahaAgX ecosystem connecting crop, AI/ML apps, advisory systems, welfare schemes, sustainability, geospatial, land, and weather"
          class="about--image"
        />
      </div>
    </div>
  </div>
</div>
